import { getToken, setToken, removeToken } from '../utils/tokenStorage';
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children, requirePayment = true }) => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const token = getToken();
      const config = token ? { 
        withCredentials: true,
        headers: { Authorization: `Bearer ${token}` }
      } : { withCredentials: true };
      
      const response = await axios.get(`${API}/auth/me`, config);
      setUser(response.data);
    } catch (error) {
      removeToken();
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Payment gate: members must pay before accessing dashboard features.
  // Admins and already-paid members pass through. The /payment route is exempt.
  if (
    requirePayment &&
    user.role !== 'admin' &&
    (user.payment_status || 'unpaid') !== 'paid' &&
    !location.pathname.startsWith('/payment')
  ) {
    return <Navigate to="/payment" replace />;
  }

  return children;
};

export default ProtectedRoute;
